import { applicationStatusSelectOptions } from '@efacity/common';
import { MenuItem, TextField } from '@mui/material';
import React, { ChangeEvent, ReactNode } from 'react';
import type { RowData } from '@tanstack/react-table';
import type { TableColumn } from '../../tableFeatures';

export const EnrollmentApplicationStatusFilter = <TableData extends RowData>({
  column
}: {
  column: TableColumn<TableData>;
}): ReactNode => {
  const value = (column.getFilterValue() as string) ?? '';

  const handleValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    column.setFilterValue(() => (value ? value : undefined));
  };

  return (
    <TextField
      select
      type="text"
      variant="outlined"
      color="primary"
      margin="dense"
      fullWidth
      onChange={handleValueChange}
      value={value || ''}
      sx={{ m: 0, backgroundColor: 'white' }}
      inputProps={{ sx: { padding: '0' } }}
      SelectProps={{ sx: { padding: 0.62, fontSize: '14px' } }}
    >
      <MenuItem key={'none'} value="">
        Any
      </MenuItem>
      {applicationStatusSelectOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
